import { bootstrapApplication } from '@angular/platform-browser';
import { KnhcRootPage } from './app/pages/app/root-page/root.page';
import { knhcConfig } from './app/knhc.config';

bootstrapApplication(KnhcRootPage, knhcConfig).catch((err) =>
  console.error(err)
);
